// ══════════════════════════════════════════════════════════════════════════════════════════════
//  t262 (16-oct-2026) · «HAY N CITAS POR ARREGLAR» — EL AVISO FIJO DE ARRIBA
// ══════════════════════════════════════════════════════════════════════════════════════════════
//  El dueño: «haya un aviso en la parte superior de la pantalla, constantemente, donde indique que hay X citas por
//  "arreglar"». Una franja de UNA línea entre la cabecera y el contenido (como components/DentroDeClinica: fuera de lo que
//  se desplaza, empuja en vez de tapar), con un clic a la lista (pages/CitasPorArreglar). Solo para quien gestiona citas
//  (el permiso `gestionar_citas`; el servidor lo vuelve a mirar y cuenta solo SUS agendas). Pregunta cada dos minutos (el
//  servidor lo tiene en memoria por clínica: services/citasPorArreglar). Con N = 0 no se pinta nada: el aviso se va solo.
import { useQuery } from '@tanstack/react-query'
import { Link, useLocation } from 'react-router-dom'
import api from '../services/api'
import { usePermisos } from '../hooks/usePermisos'
import { Ico } from './ui'
import { t } from '../utils/i18n'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

export const RUTA_CITAS_POR_ARREGLAR = '/citas-por-arreglar'
// t262b · EL NÚMERO GRANDE ES LO DE LOS PRÓXIMOS 7 DÍAS (lo urgente); el total va en pequeño (`textoTotal`). n = total,
// m = consentimientos parados, s = de los próximos 7 días.
export const textoAviso = (n, m, s = null) => {
  const partes = []
  if (n) {
    if (s == null || s === n) partes.push(t('components.AvisoCitasPorArreglar.plural_hay_citas_por_arreglar', { one: 'Hay {{count}} cita por arreglar', other: 'Hay {{count}} citas por arreglar' }, { count: n, _forma: (n === 1) ? 'one' : 'other' }))
    else if (s > 0) partes.push(t('components.AvisoCitasPorArreglar.plural_hay_citas_por_arreglar_2', { one: 'Hay {{count}} cita por arreglar en los próximos 7 días', other: 'Hay {{count}} citas por arreglar en los próximos 7 días' }, { count: s, _forma: (s === 1) ? 'one' : 'other' }))
    else partes.push(t('components.AvisoCitasPorArreglar.ninguna_cita_por_arreglar_en', 'Ninguna cita por arreglar en los próximos 7 días'))
  }
  if (m) partes.push(t('components.AvisoCitasPorArreglar.plural_consentimientos_parados', { one: '{{count}} consentimiento parado', other: '{{count}} consentimientos parados' }, { count: m, _forma: (m === 1) ? 'one' : 'other' }))
  return partes.join(' · ')
}
export const textoTotal = (n, s) => (n && s != null && s !== n ? t('components.AvisoCitasPorArreglar.en_total', '({{n}} en total)', { n }) : '')

export default function AvisoCitasPorArreglar() {
  const { permiso, permisosListos } = usePermisos()
  const { pathname } = useLocation()
  const puede = !!permisosListos && permiso('gestionar_citas') && permiso('clientes')
  const { data } = useQuery({
    queryKey: ['citas-por-arreglar-resumen'],
    queryFn: () => api.get('/citas-por-arreglar/resumen').then(r => r.data),
    enabled: puede,
    refetchInterval: 120000,
    staleTime: 60000,
    retry: false,
  })
  if (!puede || !data || data.puede === false) return null
  const n = Number(data.citas) || 0
  const m = Number(data.consentimientos) || 0
  const s = data.semana == null ? null : (Number(data.semana) || 0)
  if (!n && !m) return null
  const aqui = pathname === RUTA_CITAS_POR_ARREGLAR
  return (
    <div role="status" data-aviso-citas-por-arreglar=""
      style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px max(16px, env(safe-area-inset-right)) 6px max(16px, env(safe-area-inset-left))',
        background: 'color-mix(in srgb, var(--warning, #b45309) 14%, var(--surface))', borderBottom: '1px solid color-mix(in srgb, var(--warning, #b45309) 35%, var(--border))',
        color: 'var(--text-primary)', fontSize: 13.5, lineHeight: 1.35, minHeight: 36, flexShrink: 0 }}>
      <Ico n="warn" s={16} c="var(--warning, #b45309)" />
      <span style={{ flex: 1, minWidth: 0, fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {textoAviso(n, m, s)}{textoTotal(n, s) && <span data-aviso-total="" style={{ fontWeight: 500, fontSize: 12, color: 'var(--text-muted)', marginLeft: 6 }}>{textoTotal(n, s)}</span>}
      </span>
      {!aqui && (
        <Link to={RUTA_CITAS_POR_ARREGLAR} data-aviso-citas-por-arreglar-ir=""
          style={{ fontWeight: 800, color: 'var(--primary)', textDecoration: 'none', whiteSpace: 'nowrap', padding: '6px 4px', minHeight: 32, display: 'inline-flex', alignItems: 'center' }}>
          {t('components.AvisoCitasPorArreglar.arreglarlas', 'Arreglarlas')}
        </Link>
      )}
    </div>
  )
}
